const { min, max, pow } = Math;

const clamp = (x, absmax) => max(-absmax, min(absmax, x));

/* Ψ = Ψ g^dt */
export default class GainEquation {

	length = null;
	x = null;

	constructor(data) {
		this.length = data.length;
		this.x = data;
	}

	apply(dt, g, saturation) {
		const length = this.length;
		const x = this.x;
		/* Ψ = Ψ g^df */
		for (let i = 0; i < length; i++) {
			x[i] *= pow(g, dt);
			x[i] = clamp(x[i], saturation);
		}
	}
}
